// extracted by mini-css-extract-plugin
export default {"filterWrapper":"WorkProcessInfo_filterWrapper__Cr4Kq","spaceStyle":"WorkProcessInfo_spaceStyle__5T+2H"};